import React, { useState } from "react";
import MaterialTable from "material-table";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import useUser from "hooks/useUser";
import { materialTableLocalization } from "utils/materialTableLocalization";
import ModalUsuario from "./ModalUsuario";

export default function Usuarios() {
  const { column, data, traeUsuarios, insertaUsuario, actualizaUsuario, desbloqueaUsuario } = useUser();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("insertar");
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState(null);
  const [modalKey, setModalKey] = useState(0);
  const [snack, setSnack] = useState({ open: false, message: "", severity: "success" });

  const handleGuardar = async (datos) => {
    try {
      let result;
      if (modalMode === "insertar") {
        result = await insertaUsuario(datos);
      } else {
        result = await actualizaUsuario(datos);
      }
      if (result && result.Ok) {
        // Check if SP returned an error (e.g., duplicate user)
        const spResult = result.result && result.result[0] && result.result[0][0];
        if (spResult && spResult.sResultado === 0) {
          setSnack({ open: true, message: spResult.sMensaje, severity: "warning" });
          return result;
        }
        traeUsuarios();
        setModalOpen(false);
        setSnack({
          open: true,
          message: modalMode === "insertar" ? "Usuario creado con éxito" : "Usuario actualizado con éxito",
          severity: "success",
        });
      } else {
        let errorMsg = "Error al guardar usuario";
        if (result && result.error) {
          if (typeof result.error === "string") {
            errorMsg = result.error;
          } else if (result.error.sqlMessage) {
            errorMsg = "Error en la base de datos. Contacte al Administrador.";
          } else if (result.message) {
            errorMsg = result.message;
          }
        } else if (result && result.message) {
          errorMsg = result.message;
        }
        setSnack({ open: true, message: errorMsg, severity: "error" });
      }
      return result;
    } catch (err) {
      setSnack({ open: true, message: err.message || "Error de conexión", severity: "error" });
    }
  };

  return (
    <>
      <MaterialTable
        title="Catálogo de usuarios"
        columns={column}
        data={data}
        localization={materialTableLocalization}
        actions={[
          {
            icon: "add",
            tooltip: "Agregar Nuevo Usuario",
            isFreeAction: true,
            onClick: () => {
              setModalMode("insertar");
              setUsuarioSeleccionado(null);
              setModalKey(k => k + 1);
              setModalOpen(true);
            }
          },
          {
            icon: "edit",
            tooltip: "Editar Usuario",
            onClick: (_event, rowData) => {
              setModalMode("editar");
              setUsuarioSeleccionado(rowData);
              setModalKey(k => k + 1);
              setModalOpen(true);
            }
          },
          rowData => ({
            icon: "lock_open",
            tooltip: "Desbloquear Usuario",
            hidden: rowData.Activo !== false && rowData.Activo !== 0,
            onClick: async (_event, row) => {
              if (!window.confirm(`¿Desbloquear al usuario ${row.Usuario}?`)) return;
              const usuario = localStorage.getItem("user");
              if (!usuario) return;
              const result = await desbloqueaUsuario(row.ID_USUARIO);
              if (result && result.Ok) {
                traeUsuarios();
                setSnack({ open: true, message: "Usuario desbloqueado", severity: "success" });
              } else {
                setSnack({ open: true, message: "Error al desbloquear", severity: "error" });
              }
            }
          })
        ]}
      />
      <ModalUsuario
        key={modalKey}
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        modo={modalMode}
        usuario={usuarioSeleccionado}
        onGuardar={handleGuardar}
      />
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={snack.open}
        autoHideDuration={4000}
        onClose={() => setSnack(s => ({ ...s, open: false }))}
      >
        <MuiAlert
          onClose={() => setSnack(s => ({ ...s, open: false }))}
          severity={snack.severity}
          elevation={6}
          variant="filled"
        >
          {snack.message}
        </MuiAlert>
      </Snackbar>
    </>
  );
}
